// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_16-2";
export var blackBorderOnHover = "_16-7";
export var cell = "_16-6";
export var cellContainer = "_16-3";
export var checked = "_16-8";
export var disabled = "_16-5";
export var featuredIconCellContainer = "_16-9";
export var featuredIconTextContainer = "_16-b";
export var featuredIconWrapper = "_16-a";
export var noBorder = "_16-c";
export var orangeSelectedRow = "_3f-3";
export var overflowableText = "_16-0";
export var overflowableTextContainer = "_16-1";
export var row = "_18-0";
export var rowCheckboxCell = "_16-4";
export var selectableTable = "_3f-2";